export * from "./card-reward.component";
